module.exports = __webpack_public_path__ + "img/05.bf81ebde.webp";